import { ImageCard } from "../ImageCard"
import { TextCard } from "../TextCard"
import styles from "./TextImageCard.module.scss"
import clsx from "clsx"

export function TextImageCard({ sourceImage, sourceText, className}) {
    return (
        <div className={clsx(styles.textImageContainer, className)} >
            <div className={styles.textController}>
                <TextCard sourceText={sourceText}/>
            </div>
            <ImageCard sourceImage={sourceImage} className={styles.imageController} />
        </div>
    )
}